import { render, staticRenderFns } from "./OrganisationTypes.vue?vue&type=template&id=12305cd0&"
import script from "./OrganisationTypes.vue?vue&type=script&lang=js&"
export * from "./OrganisationTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports